export default "__VITE_ASSET__BZOLj1JX__"